import React from "react";
import type { ResponsiveValue, Theme, TLengthStyledSystem } from "styled-system";
import type { CtaButtonType } from "../../../../../../../common-deprecated/server/data/FormatBnbCtas";
import useCtaButton, { type UseCtaButtonType } from "../../../../hooks/shared/actions/useCtaButton";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";

type CtaPropsType = {
    linkType: "primary" | "negative" | "light";
    config: CtaButtonType;
    children: React.ReactNode;
    darkIcon?: boolean;
    width?: ResponsiveValue<number, Theme<TLengthStyledSystem>>;
};

type LinkPropsType = {
    linkType: CtaPropsType["linkType"];
    ctaProps: UseCtaButtonType;
    config: CtaButtonType;
    children: React.ReactNode;
    darkIcon?: boolean;
    width?: CtaPropsType["width"];
};

const LinkComponent = ({ linkType, ctaProps, children, width }: LinkPropsType): JSX.Element | null => {
    if (linkType === "primary")
        return (
            <Button.Primary as="a" width={width} {...ctaProps} m={0}>
                <Text.Button>{children}</Text.Button>
            </Button.Primary>
        );
    if (linkType === "negative")
        return (
            <Button.Outline as="a" width={width} {...ctaProps} m={0}>
                <Text.Button>{children}</Text.Button>
            </Button.Outline>
        );
    if (linkType === "light")
        return (
            <Button.PrimaryWhite as="a" type="button" width={width} {...ctaProps} m={0}>
                <Text.Button>{children}</Text.Button>
            </Button.PrimaryWhite>
        );
    return null;
};

// Ctas handled by GFI in useCtaButton
const HandledCtaButton = (props: CtaPropsType): JSX.Element | null => {
    const { linkType, config, children, darkIcon, width } = props;
    const ctaProps = useCtaButton(config);
    return (
        <LinkComponent linkType={linkType} ctaProps={ctaProps} config={config} darkIcon={darkIcon} width={width}>
            {children}
        </LinkComponent>
    );
};

const CtaButton = (props: CtaPropsType): JSX.Element | null => {
    return <HandledCtaButton {...props} />;
};

export default CtaButton;
